import type { EventName, Events, Subscriber } from './types';

function createEventEmitter() {
	const eventSubscribers = new Map<EventName, Set<Subscriber<any>>>();

	return {
		emit<T extends EventName>(eventName: T, event: Events[T]) {
			const subscribers = eventSubscribers.get(eventName);
			for (const subscriber of subscribers ?? []) {
				subscriber(event);
			}
		},
		on<T extends EventName>(eventName: T, subscriber: Subscriber<T>) {
			if (!eventSubscribers.has(eventName)) {
				eventSubscribers.set(eventName, new Set([subscriber]));
			} else {
				eventSubscribers.get(eventName)!.add(subscriber);
			}

			return () => {
				const set = eventSubscribers.get(eventName)!;
				set.delete(subscriber);

				if (set.size === 0) {
					eventSubscribers.delete(eventName);
				}
			};
		},
	};
}

export const eventEmitter = createEventEmitter();
